export default __webpack_public_path__ + "static/media/purpleK8s.dff51864.svg";